import { Link } from "react-router-dom";
import { useDomainContext } from "../../../contexts/DomainContext";
import { getCookie } from "../../../utilities/functions";
import classes from "./Footer.module.css";

const textLinksData = [
  {
    name: "Legal & Privacy",
    link: "https://www.primebridge.io/privacy",
  },
  {
    name: "Risk Disclosure",
    link: "https://www.primebridge.io/disclosure",
  },
];

const Footer = () => {
  const { companyTheme } = useDomainContext();
  const userType = getCookie("userType");
  return (
    <div className="main-divs">
      <div
        className={`${classes.wrapper} d-flex align-items-center ${
          userType === "under-company" && "justify-content-end"
        }`}
      >
        {companyTheme === "default" && (
          <>
            {" "}
            {textLinksData.map((item, i) => (
              <div key={i} className={classes.linkText}>
                <a href={item.link} alt="">
                  {item.name}
                </a>
              </div>
            ))}
            <div className={classes.copyRight}>@ 2023 Prime Bridge</div>
          </>
        )}
        {userType === "under-company" && (
          <div className={classes.linkText}>
            <Link
              to={
                companyTheme?.name === "pow"
                  ? "https://rules.team-pow.com"
                  : companyTheme?.name === "Archangel Funding"
                  ? "/archangel-funding-terms"
                  : "#"
              }
            >
              Terms of Service
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default Footer;
